/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.shopify.integration.rpc.InstallServiceRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const completeRpc = {
  serviceName: 'com.hubspot.shopify.integration.rpc.InstallServiceRpc',
  rpcName: 'complete',
  auth: 'app',
  fingerprint: 'bE_zHgwrFvmgPqg_HFMQLZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};